import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { RegExPattern } from '../../../../core/models/regexp-pattern/regex-pattern';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgxPhoneConstants } from '../../../../core/constants/ngx';

@Component({
    selector: 'app-phone-number-input',
    templateUrl: './phone-number-input.component.html',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgxMaskDirective,
        MatFormFieldModule,
        MatInputModule,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [provideNgxMask()],
})
export class PhoneNumberInputComponent {
    @Input() label: string | null = null;
    @Input() title: string = 'Phone number';
    @Input() class: string = 'w-full';
    @Input() withExtension: boolean = true;

    @Input() control: FormControl<string | null | undefined> | undefined =
        new FormControl<string | null | undefined>(undefined);

    constants = NgxPhoneConstants;
    regExPattern = RegExPattern;

    get specialCharacters(): string[] {
        return this.withExtension
            ? this.constants.SPECIAL_CHARACTERS_WITH_EXTENSION
            : this.constants.SPECIAL_CHARACTERS;
    }

    get dropSpecialCharacters(): string[] {
        return this.withExtension
            ? this.constants.DROP_SPECIAL_CHARACTERS_WITH_EXTENSION
            : this.constants.SPECIAL_CHARACTERS;
    }

    get mask(): string {
        return this.withExtension
            ? this.constants.MASK_WITH_EXTENSION
            : this.constants.MASK;
    }

    get shownMaskExpression(): string {
        return this.withExtension
            ? this.constants.SHOWN_MASK_EXPRESSION_WITH_EXTENSION
            : this.constants.SHOWN_MASK_EXPRESSION;
    }
}
